import React from 'react';

export default function Location64Icon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M32.0001 14C25.0893 14 19.5 19.5893 19.5 26.5001C19.5 35.8751 32.0001 49.7144 32.0001 49.7144C32.0001 49.7144 44.5001 35.8751 44.5001 26.5001C44.5001 19.5893 38.9108 14 32.0001 14ZM32.0004 31.8578C29.2404 31.8578 27.0004 29.5721 27.0004 26.7558C27.0004 23.9394 29.2404 21.6537 32.0004 21.6537C34.7604 21.6537 37.0004 23.9394 37.0004 26.7558C37.0004 29.5721 34.7604 31.8578 32.0004 31.8578Z" fill="currentColor"/>
    </svg>
  );
}
